var getOutage = function (accountLOB) {
    return function (domain) {
        if (domain == null)
            return 'none';
        var _a = domain.errors, allErrors = _a === void 0 ? [] : _a;
        var hasFullOutage = allErrors.some(function (_a) {
            var code = _a.code;
            return [
                "".concat(accountLOB, "_FAILURE"),
                "CCAPI_AAA_FAILURE",
                "CONSUMER_FAILURE",
            ].includes(String(code).toUpperCase());
        });
        var hasPartialOutage = allErrors.some(function (_a) {
            var code = _a.code;
            return String(code).toUpperCase() === "".concat(accountLOB, "_PARTIAL_FAILURE");
        });
        if (hasFullOutage) {
            return "full";
        }
        if (hasPartialOutage) {
            return "partial";
        }
        return "none";
    };
};
export var getAutoOutage = getOutage("AUTO");
export var getDepositOutage = getOutage("DEPOSIT");
export var getHomeLoanOutage = getOutage("HOMELOAN");
export var getInvestOutage = getOutage("INVEST");
export var getWealthOutage = getOutage("WEALTH");
export var getMortgageOutage = getOutage("MORTGAGE");
export var getCreditCardOutage = getOutage("CREDITCARD");
export var getOutages = function (domain) {
    return {
        AUTO: getAutoOutage(domain),
        DEPOSIT: getDepositOutage(domain),
        HOMELOAN: getHomeLoanOutage(domain),
        INVEST: getInvestOutage(domain),
        WEALTH: getWealthOutage(domain),
        MORTGAGE: getMortgageOutage(domain),
        CC: getCreditCardOutage(domain),
    };
};
//# sourceMappingURL=outage.js.map